// 중복되는 판매상품의 수량 더하기 및 새로운 항목 추가 메서드
export const combineDuplicates = (data) => {
  const combinedData = [];

  data.forEach((result) => {
    // 각 result.data[i].orderProducts 배열을 순회하면서 중복된 값을 합침
    result.orderProducts.forEach((item) => {
      // productName이 중복되는지 확인
      const existingItem = combinedData.find(
        (existing) => existing.productName === item.productName
      );

      if (existingItem) {
        // 이미 합쳐진 항목이 있는 경우, 수량을 더함
        existingItem.quantity += item.quantity;
      } else {
        // 합쳐진 항목이 없는 경우, 새로운 항목으로 추가
        combinedData.push({ ...item });
      }
    });
  });

  return combinedData;
};

// 전체 데이터 > 오늘 날짜 기준, 1주일 전 데이터로 필터링하는 메서드
export const filterDataByOneWeekAgo = (data, today = new Date()) => {
  const oneWeekAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000); // 오늘로부터 일주일 전의 날짜

  const filteredData = data.filter((item) => {
    // orderProducts 배열이 존재하고 최소한 하나의 요소가 있는 경우
    if (item.orderProducts && item.orderProducts.length > 0) {
      // orderProducts 배열을 순회하면서 필터링 조건을 만족하는지 확인
      return item.orderProducts.some((orderProduct) => {
        const createDateTime = new Date(orderProduct.createDateTime);
        //
        // 일주일 전의 날짜보다 이후인 경우에만 유효한 데이터로 간주
        return createDateTime >= oneWeekAgo;
      });
    }
    // orderProducts 배열이 없는 경우 또는 요소가 없는 경우는 필터링되지 않음
    return false;
  });

  return filteredData;
};

// 전체 데이터 > 오늘 날짜 기준, 당월 데이터로 필터링 하는 메서드
export const filterDataByThisMonth = (data, today = new Date()) => {
  const currentMonth = today.getMonth(); // 현재 월
  const currentYear = today.getFullYear(); // 현재 년도

  const filteredData = data.filter((item) => {
    // orderProducts 배열이 존재하고 최소한 하나의 요소가 있는 경우
    if (item.orderProducts && item.orderProducts.length > 0) {
      // orderProducts 배열을 순회하면서 필터링 조건을 만족하는지 확인
      return item.orderProducts.some((orderProduct) => {
        const createDateTime = new Date(orderProduct.createDateTime);
        //
        const orderMonth = createDateTime.getMonth(); // 주문된 월
        const orderYear = createDateTime.getFullYear(); // 주문된 년도
        // 현재 월과 년도와 주문된 월과 년도가 일치하는 경우에만 유효한 데이터로 간주
        return orderMonth === currentMonth && orderYear === currentYear;
      });
    }
    // orderProducts 배열이 없는 경우 또는 요소가 없는 경우는 필터링되지 않음
    return false;
  });

  return filteredData;
};

// 매출을 구하는 메서드
export const getTotalAmount = (data) => {
  let totalAmount = 0;

  // 데이터를 순회하면서 각 아이템의 amount를 합산
  data.forEach((item) => {
    if (item.amount) {
      totalAmount += item.amount;
    }
  });

  return totalAmount;
};

// 오늘 날짜 기준 > [월~일] 주간을 구하는 메서드
export const filterDataByThisWeek = (data, today = new Date()) => {
  

  // 오늘 날짜의 요일을 구함 (0: 일요일, 1: 월요일, ..., 6: 토요일)
  const currentDayOfWeek = today.getDay();

  // 오늘로부터 월요일까지의 경과 일수 계산
  let daysToMonday = 1 - currentDayOfWeek;
  if (daysToMonday > 0) {
    daysToMonday -= 7;
  }

  // 월요일 날짜를 구함 (시간은 00:00:00)
  const mondayDate = new Date(today);
  mondayDate.setDate(today.getDate() + daysToMonday);
  mondayDate.setHours(0, 0, 0, 0);
  

  // 일주일 후 일요일 날짜를 구함 (시간은 23:59:59)
  const sundayDate = new Date(mondayDate);
  sundayDate.setDate(mondayDate.getDate() + 6);
  sundayDate.setHours(23, 59, 59, 999);
  

  // 월요일부터 일요일까지의 범위로 필터링
  const filteredData = data.filter((item) => {
    // orderProducts 배열이 존재하고 최소한 하나의 요소가 있는 경우
    if (item.orderProducts && item.orderProducts.length > 0) {
      // orderProducts 배열을 순회하면서 필터링 조건을 만족하는지 확인
      return item.orderProducts.some((orderProduct) => {
        const createDateTime = new Date(orderProduct.createDateTime);
        //
        // 월요일부터 일요일까지의 범위에 속하는 경우에만 유효한 데이터로 간주
        return createDateTime >= mondayDate && createDateTime <= sundayDate;
      });
    }
    // orderProducts 배열이 없는 경우 또는 요소가 없는 경우는 필터링되지 않음
    return false;
  });

  

  return filteredData;
};

// 오늘 날짜 데이터만 필터링하는 메서드
export const filterDataByToday = (data, today = new Date()) => {
  const currentDate = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );

  // 오늘 날짜로 필터링
  const filteredData = data.filter((item) => {
    // orderProducts 배열이 존재하고 최소한 하나의 요소가 있는 경우
    if (item.orderProducts && item.orderProducts.length > 0) {
      // orderProducts 배열을 순회하면서 필터링 조건을 만족하는지 확인
      return item.orderProducts.some((orderProduct) => {
        const createDateTime = new Date(orderProduct.createDateTime);
        // 주문 생성일이 오늘 날짜와 동일한 경우에만 유효한 데이터로 간주
        return (
          createDateTime.getFullYear() === currentDate.getFullYear() &&
          createDateTime.getMonth() === currentDate.getMonth() &&
          createDateTime.getDate() === currentDate.getDate()
        );
      });
    }
    // orderProducts 배열이 없는 경우 또는 요소가 없는 경우는 필터링되지 않음
    return false;
  });

  return filteredData;
};

// 올해 데이터를 필터링하는 메서드
export const filterDataByThisYear = (data, today = new Date()) => {
  const currentYear = today.getFullYear(); // 현재 년도
  const startOfYear = new Date(currentYear, 0, 1); // 올해의 시작일

  // 올해의 시작일부터 현재 날짜까지의 범위로 필터링
  const filteredData = data.filter((item) => {
    // orderProducts 배열이 존재하고 최소한 하나의 요소가 있는 경우
    if (item.orderProducts && item.orderProducts.length > 0) {
      // orderProducts 배열을 순회하면서 필터링 조건을 만족하는지 확인
      return item.orderProducts.some((orderProduct) => {
        const createDateTime = new Date(orderProduct.createDateTime);
        // 올해의 시작일부터 현재 날짜까지의 범위에 속하는 경우에만 유효한 데이터로 간주
        return createDateTime >= startOfYear && createDateTime <= today;
      });
    }
    // orderProducts 배열이 없는 경우 또는 요소가 없는 경우는 필터링되지 않음
    return false;
  });

  return filteredData;
};

// 요일별 매출을 구하는 메서드
export const getDailySales = (data) => {
  // 요일별 매출을 저장할 배열
  const dailySales = [0, 0, 0, 0, 0, 0, 0]; // 월요일부터 일요일까지
  

  // 데이터를 순회하면서 각 아이템의 매출을 요일별로 누적
  data.forEach((item) => {
    
    
    // orderProducts 배열이 존재하고 최소한 하나의 요소가 있는 경우
    if (item.amount) {
      if (item.orderProducts && item.orderProducts.length > 0) {
        const createDateTime = new Date(item.orderProduct.createDateTime);
        //
        const dayOfWeek = (createDateTime.getDay() + 6) % 7; // 0: 월요일, 1: 화요일, ..., 6: 일요일
        //
        // amount가 정의되어 있는지 확인하고, 정의되어 있다면 더하기 연산 수행
        if (
          item.orderProduct.amount !== undefined &&
          !isNaN(item.orderProduct.amount)
        ) {
          dailySales[dayOfWeek] += item.orderProduct.amount;
        }
        //
      }
    }
  });

  return dailySales;
};
